export default __webpack_public_path__ + "static/media/Pharmacy_supply_aid_checklist.dc7a613e.pdf";